import LogoIcon from '@/assets/logo-icon.svg?react'
import { GENERAL_CONTACT_URL } from '@/config/constants'
import { Box, Flex, Link, Separator, Spacer, Text } from '@chakra-ui/react'
import { useTranslation } from '@infraloop/i18n'

/**
 * Footer for the signed-out pages. The dashboard footer's user-manual and terms-of-service
 * entries are left out on purpose — both are only meaningful once someone is signed in, which
 * is how the legacy footer behaved for visitors.
 */
const PublicFooter = () => {
  // Hooks
  const { t } = useTranslation()

  return (
    <Box as="footer" w="100%" mt={5}>
      <Separator />
      <Flex align="center" gap="13px" my={5}>
        <Box asChild>
          <LogoIcon width="32px" height="32px" title="Hatsuly" />
        </Box>
        <Text fontSize="13px" color="gray.500">
          {t('hatsuly.footer.copyright')}
        </Text>
        <Spacer />
        <Link
          href={GENERAL_CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
          fontSize="13px"
          color="gray.500"
          textDecoration="none"
          _hover={{ color: 'gray.700' }}
          data-testid="public-footer-contact"
        >
          {t('hatsuly.footer.contact')}
        </Link>
      </Flex>
    </Box>
  )
}

export default PublicFooter
